var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.ready && _vm.accessible)?_c('v-container',{staticClass:"pa-0",attrs:{"fluid":"","body":""}},[_c('router-view',{attrs:{"name":"dialog"}}),_c('router-view')],1):_c('Container',{attrs:{"loaded":_vm.ready,"accessible":_vm.accessible,"error":'403',"viewn":'observation'}})
}
var staticRenderFns = []

export { render, staticRenderFns }